import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ReportsService {

	rootUri = (environment.ktRootUri) ? environment.ktRootUri : "";

	constructor(
		private http: HttpClient
	) { }

	getWrongAnswerReport(set_id: number) {
		return this.http.get(`${this.rootUri}/api/reports/wrong-answers/${set_id}`);
	}

	getNumberOfLiveGames(): Observable<number> {
		return this.http.get<number>(`${this.rootUri}/api/reports/total-live-games`);
	}

	getNumberOfLiveShifts(): Observable<number> {
		return this.http.get<number>(`${this.rootUri}/api/reports/total-live-shifts`);
	}
	getNumberOfTeams(): Observable<number> {
		return this.http.get<number>(`${this.rootUri}/api/reports/total-teams`);
	}
	getNumberOfPlayers(): Observable<number> {
		return this.http.get<number>(`${this.rootUri}/api/reports/total-players`);
	}
	getScheduledTasks(): Observable<ScheduledTasks[]> {
		return this.http.get<ScheduledTasks[]>(`${this.rootUri}/api/reports/scheduled-tasks`);
	}

	getServerStats(): Observable<ServerStats> {
		return this.http.get<ServerStats>(`${this.rootUri}/api/reports/server-stats`);
	}

	getHistoricalDashboardStats(): Observable<StatsArchive[]> {
		return this.http.get<StatsArchive[]>(`${this.rootUri}/api/reports/historical-records`)
  }

  getHostStatsReport() {
    return this.http.get(`${this.rootUri}/api/reports/host-stats`);
  }

  getStatsForHost(userid: string) {
    return this.http.get(`${this.rootUri}/api/admin/host-stats/${userid}`);
  }

  getHostedVenuesForHost(userid: string) {
    return this.http.get(`${this.rootUri}/api/admin/host-venues/${userid}`);
  }

	getPlayersByVenue(venue: string, date_from: string, date_to: string): Observable<PlayersByVenue> {
		return this.http.post<PlayersByVenue>(`${this.rootUri}/api/reports/players-by-venue`, { venue, date_from, date_to })
	}

  getRedisKeys(cursor: number = 0, match: string = '*', count: number = 10): Observable<RedisScanResult> {
    return this.http.get<RedisScanResult>(`${this.rootUri}/api/reports/redis-keys`,
			{
				params:
				{ 'cursor': cursor.toString(), 'match': match.toString(), 'count': count.toString() }
			}
		);
  }

  getKeyValue(key: string, type: string): Observable<RedisScanResult> {
    return this.http.get<any>(`${this.rootUri}/api/reports/redis-keys/read/${key}/${type}`);
  }

  deleteRedisCache(key: string): Observable<SuccessResponse> {
    return this.http.delete<SuccessResponse>(`${this.rootUri}/api/reports/redis-keys/delete/${key}`);
  }

  getInactiveWorkersReport(cutoff: string): Observable<InactiveWorkers[]> {
    return this.http.post<InactiveWorkers[]>(`${this.rootUri}/api/reports/inactive-workers-report`, { cutoff });
  }

  getVenuesLowScratchPaper(weeks_threshold: number, num_of_games: number): Observable<VenuesLowScratchPaper[]> {
    return this.http.post<VenuesLowScratchPaper[]>(`${this.rootUri}/api/reports/venues-low-on-scratch-paper`, { weeks_threshold, num_of_games });
  }

  updateVenuePaperSupply(venue_id: number, paper_supply: number): Observable<SuccessResponse> {
    return this.http.post<SuccessResponse>(`${this.rootUri}/api/venue/${venue_id}/update-paper-supply`, { paper_supply });
  }

  getVenuesHistoricalCancellations(date_from: string, date_to: string): Observable<VenuesHistoricalCancellation[]> {
    return this.http.post<VenuesHistoricalCancellation[]>(`${this.rootUri}/api/reports/venues-historical-cancellations/`, { date_from, date_to });
  }

  getVenueHealthReport(months_threshold: number): Observable<VenueHealthReport[]> {
    return this.http.get<VenueHealthReport[]>(`${this.rootUri}/api/reports/venue-health`);
  }
}
